<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Add Pre Alert Manifest
        <i class="caption red--text ml-4"> * required field</i>
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-card class="elevation-2" style="width: 100%">
      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-row class="text-center py-0">
            <v-col
              cols="12"
              sm="4"
              v-if="userCategory.user_category == 3"
              class="pb-0"
            >
              <v-autocomplete
                v-model="formData.client_id"
                :items="clients"
                :loading="clientLoader"
                hide-no-data
                item-text="name"
                item-value="id"
                label="Select Client"
                placeholder="Start typing to Search"
                class="required text-center pb-0"
                :rules="[(v) => !!v || 'Please select client']"
                return-object
                @focus="fetchClientList"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" class="pb-0">
              <v-autocomplete
                v-model="formData.origin_id"
                :items="airportCodes"
                item-key="id"
                item-text="displayText"
                item-value="id"
                label="Origin Airport"
                class="required text-center pb-0"
                :loading="airportCodes.length == 0 ? true : false"
                :rules="[(v) => !!v || 'Please select Airport']"
                outlined
              >
                <template v-slot:item="{ item }">
                  {{ item.airport_name }} ({{ item.iata_code }})
                  {{ item.country_name }}
                </template></v-autocomplete
              >
            </v-col>
            <v-col cols="12" sm="4" class="pb-0">
              <v-autocomplete
                v-model="formData.destination_id"
                :items="airportCodes"
                item-text="displayText"
                item-value="id"
                label="Destination Airport"
                class="required text-center pb-0"
                :loading="airportCodes.length == 0 ? true : false"
                outlined
                :rules="[(v) => !!v || 'Please select Airport']"
              >
                <template v-slot:item="{ item }">
                  {{ item.airport_name }} ({{ item.iata_code }})
                  {{ item.country_name }}
                </template></v-autocomplete
              >
            </v-col>
            <v-col cols="12" sm="4" class="pb-0">
              <v-text-field
                v-model="formData.sender_name"
                outlined
                label="Sender Name"
                class="required pb-0"
                :rules="[(v) => !!v || 'Sender Name is required.']"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="pb-0">
              <v-text-field
                v-model="formData.flight_no"
                label="Flight Number"
                class="required pb-0"
                :rules="[(v) => !!v || 'Flight Number is required.']"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="pb-0">
              <v-text-field
                v-model="formData.mawb_no"
                label="Mawb Number"
                class="required pb-0"
                :rules="[(v) => !!v || 'Mawb Number is required.']"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" class="pb-0">
              <v-file-input
                v-model="formData.mawb_file"
                label="Mawb File"
                class="required pb-0"
                outlined
                prepend-icon=""
                @click="formData.mawb_file = null"
                append-icon="mdi-paperclip"
                :rules="[
                  (v) => !!v || 'Mawb File is required.',
                  (v) =>
                    (v && v.type === 'application/pdf') ||
                    'Only pdf files are allowed.',
                ]"
                accept=".pdf"
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="4" class="mt-0 pb-0">
              <v-menu
                v-model="dateFilterD"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                outlined
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(formData.departure_date)"
                    label="Departure Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    clearable
                    @click:clear="clearInput('formData.departure_date')"
                    :rules="[(v) => !!v || 'Departure is required.']"
                    class="required mt-0 pt-0 pb-0"
                    outlined
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="formData.departure_date"
                  @input="dateFilterD = false"
                  :min="getEndDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="4" class="mt-0 pb-0">
              <v-menu
                v-model="dateFilterA"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    :value="getFormattedDate(formData.arrival_date)"
                    label="Arrival Date"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    class="required mt-0 pt-0 pb-0"
                    clearable
                    @click:clear="clearInput('formData.arrival_date')"
                    outlined
                    :rules="[(v) => !!v || 'Arrival date is required.']"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="formData.arrival_date"
                  @input="dateFilterA = false"
                  :min="getEndDate"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" sm="4" class="pb-0">
              <v-autocomplete
                v-model="formData.injection_type_id"
                :items="injectionType"
                item-text="text"
                item-value="value"
                label="Injection Type"
                class="required pb-0"
                return-object
                outlined
                :rules="[(v) => !!v || 'Injection Type is required.']"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4" class="pb-0">
              <v-text-field
                v-model="formData.total_weight"
                label="Total Weight (In Kg)"
                class="required pb-0"
                outlined
                :rules="[(v) => !!v || 'Total Weight (In Kg) is required.']"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="4" class="pb-0">
              <v-file-input
                v-model="formData.data_file"
                label="Upload file"
                clearable
                outlined
                prepend-icon=""
                append-icon="mdi-paperclip"
                class="required mt-0 pt-0 pb-0"
                @click="formData.data_file = null"
                :rules="[
                  (v) => !!v || 'File is required.',
                  (v) =>
                    (v &&
                      [
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                      ].includes(v.type) &&
                      v.size < 10000000) ||
                    'Only excel files are allowed and max size is 10mb.',
                ]"
                accept=".xlsx"
              >
              </v-file-input>
            </v-col>
          </v-row>

          <div class="text-left">
            <v-btn
              color="primary"
              dark
              class="mt-3"
              small
              :loading="saveLoader"
              @click="save()"
            >
              Upload
            </v-btn>
            <v-btn
              color="info"
              class="mt-3 ml-2"
              small
              :loading="downloader"
              @click="downloadTemplate()"
              >Download template</v-btn
            >
            <v-btn
              small
              color="white"
              class="ml-4 mt-3"
              @click="$router.push('/preAlert')"
              >Cancel</v-btn
            >
          </div>
        </v-form>
      </v-card-text>
    </v-card>
    <BulkErrors
      :dialog="uploadResDialog"
      :data="uploadRes"
      @close="uploadResDialog = false"
    />
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import BulkErrors from "@/components/front/common/BulkErrors";

export default {
  components: { BulkErrors },

  data: () => ({
    detailsData: [],
    saveLoader: false,
    injectionType: [
      { text: "Transit via DXB", value: 0 },
      { text: "Direct", value: 1 },
    ],
    orderdetailsPopup: false,
    selectedClient: "",
    dateMenu: false,
    dateMenuFrom: false,
    dateFilter: false,
    dateFilterarrival: false,
    rcvDate: null,
    dateMenuRcv: false,
    chargedAmount: null,
    receiveAmount: null,
    transactionNumberFill: null,
    orderItem: {},
    dateFilterD: false,
    dateFilterA: false,
    departure_date: null,
    arrival_date: null,
    loader: false,
    filePVerify: null,
    file: null,
    downloader: false,
    uploaderPUpload: false,
    uploadResDialog: false,
    uploadRes: {},
    dialog: false,
    exitdialog: false,
    boeexitLoader: false,
    fileLoader: false,
    fileDocLoader: false,
    fileDataLoader: false,
    formData: {
      data_file: null,
      client_id: null,
      origin_id: null,
      destination_id: null,
      sender_name: null,
      flight_no: null,
      mawb_no: null,
      mawb_file: null,
      departure_date: null,
      arrival_date: null,
      injection_type_id: "",
      total_weight: null,
    },
    receipt: "",
    detailsPopup: false,
    mawb_no: null,
    hawb: null,
    clients: [],
    transactionDate: "",
    status: "",
    carrier: "",
    pendingModal: false,
    rsaLoader: false,
    totals: 0,
    itemFound: {},
    payment_id: null,
    editedIndex: -1,
    orderdetailsRow: false,
    previusPage: false,
    countries: [],
    airportCodes: [],
  }),

  created() {
    this.fetchClientList();
    this.getAirportCodes();
  },
  computed: {
    ...mapGetters(["userCategory"]),

    getEndDate() {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() + 1);
      endDate.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to zero
      return endDate.toISOString().split("T")[0]; // Keep only the date part
    },
  },
  methods: {
    ...mapActions([
      "snackBar",
      "getPrealertList",
      "fetchClient",
      "getBaseAirportCodes",
      "addPreAlert",
      "preAlertorderDetails",
      "downloadPrealertTemplate",
    ]),
    getAirportCodes() {
      this.getBaseAirportCodes().then((res) => {
        this.airportCodes = res.data;
        this.airportCodes.map((item) => {
          item.displayText = `${item.airport_name}, ${item.iata_code} ,${item.country_name}`;
        });
      });
    },
    downloadTemplate() {
      this.downloader = true;
      this.downloadPrealertTemplate()
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    fetchClientList() {
      if (this.clients.length) return;
      if (this.clients.length === 0 && this.userCategory.user_category === 3) {
        this.clientLoader = true;
        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "clickdna",
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    clearInput(val) {
      if (val == "formData.departure_date") {
        this.formData.departure_date = "";
      } else if (val == "formData.arrival_date") {
        this.formData.arrival_date = "";
      }
    },
    save() {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.saveLoader = true;
      const payload = new FormData();
      if (
        this.formData.client_id !== null &&
        this.formData.client_id !== undefined &&
        this.formData.client_id !== ""
      )
        payload.append("client_id", this.formData.client_id.id);
      payload.append("origin_id", this.formData.origin_id);
      payload.append("destination_id", this.formData.destination_id);
      payload.append("sender_name", this.formData.sender_name);
      payload.append("flight_no", this.formData.flight_no);
      payload.append("mawb_no", this.formData.mawb_no);
      payload.append("mawb_file", this.formData.mawb_file);

      payload.append("departure_date", this.formData.departure_date);
      payload.append("arrival_date", this.formData.arrival_date);
      payload.append(
        "injection_type_id",
        this.formData.injection_type_id.value
      );
      payload.append("total_weight", this.formData.total_weight);
      payload.append("data_file", this.formData.data_file);

      this.addPreAlert(payload)
        .then((res) => {
          this.addDialog = false;
          this.uploadRes = res.data;
          this.uploadResDialog = true;
          this.saveLoader = false;
          this.$router.push("/preAlert");
        })
        .catch(() => {
          this.saveLoader = false;
        });
    },

    reset() {
      this.file = "";
      this.addDialog = false;
      this.dialog = "";
      this.$refs.form?.reset();
      this.$refs.form1?.reset();
      this.formData = {};
      this.editedIndex = -1;
      this.orderdetailsRow = false;
    },

    close() {
      this.dialog = false;
      this.exitdialog = false;
    },
  },
};
</script>
